import { render, staticRenderFns } from "./MarqueeRolln.vue?vue&type=template&id=44de3e72&scoped=true"
import script from "./MarqueeRolln.vue?vue&type=script&lang=js"
export * from "./MarqueeRolln.vue?vue&type=script&lang=js"
import style0 from "./MarqueeRolln.vue?vue&type=style&index=0&id=44de3e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44de3e72",
  null
  
)

export default component.exports